import React from 'react';
import graphql from 'graphql';
// import ContactSection from 'components/Contact';
import Footer from 'components/Footer';
import '../sass/theme/index.scss';
import '../sass/overwrite.scss';

export default class App extends React.Component {
  render() {
    // eslint-disable-next-line
    const { data, location } = this.props;
    console.log(this.props);
    let rootClasses = '';
    switch (location.pathname) {
      case '/':
        rootClasses = 'dark-header';
        break;
      case '/why-us':
        rootClasses = 'transparent-header why-us-page';
        break;
      case '/capabilities/progressive-web-apps':
        rootClasses = 'transparent-header white-bg-right pwa-page';
        break;
      default:
        rootClasses = 'transparent-header';
        break;
    }
    return (
      <div className={`root-cont ${rootClasses}`}>
        <main className="main-cont">{this.props.children()}</main>
        <div id="backtotop">
          <a href="#" />
        </div>
        <Footer location={location} />
      </div>
    );
  }
}

export const pageQuery = graphql`
  query LayoutIndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          frontmatter {
            title
            contentType
            date(formatString: "MMMM DD, YYYY")
            path
            summary
            newsFlag
            postimage
            button
            header
            personName
            personRole
            mission
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
    allFile(
      sort: { fields: [relativeDirectory, name], order: ASC }
      filter: { sourceInstanceName: { eq: "pages" }, name: { regex: "/^(?!(404|.DS_Store|blog|contact)$).+$/" } }
    ) {
      edges {
        node {
          name
          relativeDirectory
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx